import { useState } from 'react';
import { buildPreviewUrl, getPreviewSelection } from './helpers';
import type { Survey } from '@api/surveys/utilities/types';

export const usePreviewSelection = (survey: Survey) => {
  const [surveyPreviewSelection, setSurveyPreviewSelection] = useState(() =>
    getPreviewSelection(survey)
  );
  const iframeUrl = buildPreviewUrl({
    previewSelection: surveyPreviewSelection,
    surveyId: survey.id,
  });

  const handleUpdatePreviewQuotaGroup = (quotaGroupId: string) => {
    setSurveyPreviewSelection((prev) => {
      return {
        ...prev,
        quotaGroupId,
      };
    });
  };

  const resetPreviewSelection = () => {
    const defaultSelection = getPreviewSelection(survey);
    setSurveyPreviewSelection(defaultSelection);
  };

  return [surveyPreviewSelection, iframeUrl, handleUpdatePreviewQuotaGroup, resetPreviewSelection];
};
